module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Semibold.f14eee64.otf";